import Navbar from "../../../../Components/Desktop/Navbar/Navbar";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import "../../ProductPages/ProductPages.scss";
import RequestDemo from "../../../../Components/Desktop/RequestDemo/RequestDemo";
import Footer from "../../../../Components/Desktop/Footer/Footer";
import Carousel from "react-multi-carousel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

interface MIntegrationExcellenceProps {
    journey: {
        head: string;
        content: string;
    }[];
    why_choose: {
        img: string;
        title: string;
        desc: string;
    }[];
    carousel_responsive: {
        mobile: {
            breakpoint: { max: number; min: number };
            items: number;
            slidesToSlide: number;
        };
    };
}

const IntegrationExcellence = ({
    journey,
    why_choose,
    carousel_responsive,
}: MIntegrationExcellenceProps) => {
    const navbarStyle = { backgroundColor: "#6458D8", color: "#ffffff" };
    const image = "./images/insurevent_logo_white.svg";
    const settings = {
        dots: true,
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "0",
        slidesToShow: 3,
        speed: 500,
        autoplay: true,
    };

    return (
        <>
            <Navbar
                style={navbarStyle}
                image={image}
                class1="whiteMenu"
                border="border" />

            <Box className="productPage_wrapper">
                <Box className="productHeader_section" marginBottom={"80px"}>
                    <Grid container spacing={3} className="row">
                        <Grid sm={12} md={7} lg={6} alignSelf={"center"}>
                            <h1>
                                Welcome to Insurvent – Unleashing Seamless Integration Excellence for Sales Partners and Insurance Companies!
                            </h1>
                        </Grid>
                        <Grid sm={12} md={5} lg={6}
                            textAlign={"end"}
                            className="text-md-center header_image"
                            padding={'90px 46px'}
                        >
                            <img
                                src="./images/integration_excellence_header.svg"
                                alt="erp"
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box className="productInfo_wrapper integration_info" marginBottom={"80px"}>
                    <Grid container spacing={3} className="row">
                        <Grid xs={12}>
                            <Box className="productInfo_section">
                                <Grid container spacing={3} className="row">
                                    <Grid xs={6}>
                                        <img
                                            src={"./images/integration_desc_img.svg"}
                                            alt="erp_desc"
                                            style={{ maxHeight: "380px" }}
                                        />
                                    </Grid>
                                    <Grid xs={6} alignSelf={"center"}>
                                        <h5 className="main_title mb-2">
                                            Integration Support Hub: <span>Elevating Sales Partners</span>
                                        </h5>
                                        <p style={{ textAlign: 'justify' }}>
                                            At Insurvent, we recognize the pivotal role our Sales Partners play in shaping success within the competitive insurance landscape. Our Integration Support Hub is more than just a resource – it's a commitment to empowering you with seamless tools, personalized resources, and unwavering support. Whether you're a large agency or an individual agent, our goal is to enhance your capabilities, simplify processes, and elevate your journey to unparalleled success.
                                        </p>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box className="integration_services_features integration_journey" marginBottom={"110px"}>
                    <Grid container spacing={3} className="row">
                        <Grid xs={12} textAlign={'center'}>
                            <Box className="difference_innerSection">
                                <h6 className="main_title">
                                    Empowering<span> Your Journey</span></h6>
                                <Box className="carousel_part">
                                    <Slider {...settings}>
                                        {journey?.map((data, i) => (
                                            <Box className="journey_box">
                                                <h5>{data.head}</h5>
                                                <p>{data.content}</p>
                                            </Box>
                                        ))}
                                    </Slider>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box className="insurvent_advantage integration_advantage" marginBottom={"80px"}>
                    <Grid container columnSpacing={3} className="row">
                        <Grid xs={12} textAlign={'center'}>
                            <h6 className="main_title mb-10">
                                Why Choose
                                <span> Insurvent </span>
                            </h6>
                        </Grid>
                        <Grid xs={12}>
                            <Carousel
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={carousel_responsive}
                                infinite={true}
                                autoPlay={false}
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                autoPlaySpeed={5000}
                                arrows={false}
                                customTransition={"transform 800ms ease-in-out"}
                            >
                                {why_choose?.map((data, i) => (
                                    <Grid container columnSpacing={3}>
                                        <Grid xs={6} className="choosing">
                                            <span>0{i + 1}</span>
                                            <h5 className="main_title mt-32">{data.title}</h5>
                                            <p>{data.desc}</p>
                                        </Grid>
                                        <Grid xs={6} textAlign={'center'}>
                                            <img style={{ margin: '0 auto' }} src={data.img} alt="d" />
                                        </Grid>
                                    </Grid>
                                ))}
                            </Carousel>
                        </Grid>
                    </Grid>
                </Box>

                <Box marginBottom={"80px"}>
                    <Grid container spacing={3} className="row">
                        <Grid xs={12}>
                            <Box
                                sx={{
                                    background: "#F3F2FC",
                                    borderRadius: "12px",
                                    padding: "24px",
                                }}
                            >
                                <p style={{ textAlign: "center" }}>
                                    Join Insurvent's Integration Hub with confidence, knowing that we are committed to elevating your success. From Sales Partners to Insurance Companies, we welcome you to a partnership where innovation seamlessly meets reliability for a future-proofed journey in the dynamic insurance landscape.
                                </p>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <RequestDemo
                    formHeading={
                        <>
                            Request a<span> Demo</span>
                        </>
                    }
                    formDesc={
                        "Experience the Future: Request a Demo and Witness the Power of Our Solutions in Action!"
                    }
                    formImg_url={"./images/request_demo_img.png"}
                />
            </Box>

            <Footer />
        </>
    );
}

export default IntegrationExcellence